import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HeaderMobile from './components/Header';
import { addDays, format } from 'date-fns';
import BidGroup from './components/BidGroup';
import { dateToString } from '../../utils/Library';
import { useAuth } from '../../contexts/AuthContext';
import { usePost } from '../../apis/ApiRequests';
import InfoIcon from '@mui/icons-material/Info';
import { Button} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const BidGroupMobile = () => {

    const { authInfo } = useAuth();
    const navigate = useNavigate();
    
    const search     = useLocation().search;
    const query      = new URLSearchParams(search);
    const bidGroupNo = query.get('bidGroupNo');
    const targetDate = query.get('targetDate');
    const today      = targetDate ? targetDate : format(addDays(new Date(), 0), 'yyyy-MM-dd');

	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode = authInfo.facilityCode;
    const facilityName = authInfo.facilityName;
    const userId       = authInfo.userId;
    const userName     = authInfo.userName;
    const authority    = authInfo.authority;
    const traderCode   = authInfo.traderCode;
    const trader       = authInfo.trader;
    
	//-----------------------------------------------
	// initialize - useState
	//-----------------------------------------------
	const [ searchCount,    setSearchCount    ] = useState(0);
	const [ bidGroupList,   setBidGroupList   ] = useState([]);
	const [ dataGridHeight, setDataGridHeight ] = useState(window.innerHeight - 280);
    const [ scrollToId,     setScrollToId     ] = useState(null);
    
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
	// API - searchData / BidGroup
	//-----------------------------------------------
	const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost();
	const searchData = async () => {
        const numericDate = dateToString(today);
        const methodName = Number(authority) === 3 ? 'searchDataByTrader' : 'searchData';
        const postData = {
            'className'    : 'mch.models.table.BidGroup',
            'methodName'   : methodName,
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : numericDate,
            'keyword2'     : '',
            'keyword3'     : ''
        }
        await searchData_post(postData);
	};
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1);
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 280);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
        
    },[]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData();
    }, [searchCount]);

	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        if (scrollToId) {
            const element = document.getElementById(scrollToId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [scrollToId]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchData / BidGroup)
	//-----------------------------------------------
    useEffect(() => {
        setBidGroupList([]);
        if (searchData_res) {
            setBidGroupList(searchData_res.Data);
            setScrollToId(bidGroupNo);
        }
    }, [searchData_res]);
    
    const handleClick = (menu) => {
        navigate(menu);
    };

    const header_date = {
        marginLeft   : '0px',
        marginRight  : '20px',
        padding      : '7px 10px 5px 10px',
        height       : '47px',
        borderRadius : '10px',
        color        : '#305496',
        fontSize     : '22px',
        width        : '100%',
        fontWeight   : 'bold'
    };
    const container = {
        backgroundColor:'orange', color:'#fff', fontSize:'20px',border : '1px solid #fff',borderRadius : '10px', padding : '10px', width: '100%', marginBottom: '10px'
    };
    return (
        <>
            <HeaderMobile />
            <div className='bidList bodyContens' style={{marginTop:'60px'}}>
                <div style={header_date}>{ today }の入札情報</div>
                <div style={{marginTop:'1em', width: '100%', height: dataGridHeight, marginBottom: '10px', overflowY:'scroll'}}>
                    
                {
                    bidGroupList.map(item => (
                        <div id={ item.bidGroupNo } onClick={() => handleClick(`/bidManagerMobile?targetDate=${today}&bidGroupNo=${ item.bidGroupNo }`)}>
                            <BidGroup bidGroup = {item}/>
                        </div>
                    ))
                }
                {
                    bidGroupList.length == 0 ?
                    <>
                    <div style={container}>
                    現在入札は行われていません
                    </div>
                    </>
                    :
                    <></>
                }
                </div>
            </div>
            <div style={{ position: 'fixed', left: 0, bottom: 0, width: '100%', color: 'white', textAlign: 'center', }}>
                <Button
                    color     = "secondary"
                    size      = "large"
                    style     = {{ fontSize: '20px', width: '90%',marginBottom: '1rem', color:'#fff', }}
                    variant   = "contained"
                    startIcon = {<RefreshIcon />}
                    onClick   = {() => { setSearchCount(searchCount+1) }}
                >
                最新情報を読み込む
                </Button>
                <Button
                        color     = "secondary"
                        size      = "large"
                        style     = {{ fontSize: '20px', width: '90%',marginBottom: '1rem', color:'#fff', backgroundColor:'grey' }}
                        variant   = "contained"
                        startIcon = {<InfoIcon />}
                        onClick   = {() => { navigate(`/homeMobile`) }}
                >ホームへ戻る
                </Button>
            </div>
        </>
    )
}

export default BidGroupMobile;